/* SpectraPure filters.js — URL-driven faceted filters.
 * Submits filter form via fetch and replaces grid content.
 */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const filterForm = $('[data-filter-form]');
  const grid = $('[data-collection-grid]');
  if (!filterForm || !grid) return;

  let pending;

  function applyFilters() {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams();
    for (const [k, v] of formData.entries()) {
      if (v !== '') params.append(k, v);
    }
    const url = `${window.location.pathname}?${params.toString()}`;
    fetchAndReplace(url);
  }

  async function fetchAndReplace(url) {
    if (pending) pending.abort();
    pending = new AbortController();
    grid.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(url, { signal: pending.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-collection-grid]');
      const newToolbar = doc.querySelector('[data-collection-toolbar]');
      const newActive = doc.querySelector('[data-active-filters]');
      if (newGrid) grid.innerHTML = newGrid.innerHTML;
      if (newToolbar) {
        const tb = $('[data-collection-toolbar]');
        if (tb) tb.innerHTML = newToolbar.innerHTML;
      }
      if (newActive) {
        const af = $('[data-active-filters]');
        if (af) af.innerHTML = newActive.innerHTML;
      }
      history.pushState({}, '', url);
      grid.setAttribute('aria-busy', 'false');
      window.scrollTo({ top: grid.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    } catch (e) {
      if (e.name !== 'AbortError') grid.setAttribute('aria-busy', 'false');
    }
  }

  filterForm.addEventListener('change', () => applyFilters());
  filterForm.addEventListener('submit', (e) => { e.preventDefault(); applyFilters(); });

  // Active filter chip removal (delegated in DOM)
  document.addEventListener('click', (e) => {
    const chipBtn = e.target.closest('[data-remove-filter]');
    if (!chipBtn) return;
    e.preventDefault();
    const param = chipBtn.getAttribute('data-remove-filter');
    const value = chipBtn.getAttribute('data-remove-value') || '';
    const url = new URL(window.location.href);
    if (value) {
      const remaining = url.searchParams.getAll(param).filter(v => v !== value);
      url.searchParams.delete(param);
      remaining.forEach(v => url.searchParams.append(param, v));
    } else {
      url.searchParams.delete(param);
    }
    fetchAndReplace(url.pathname + (url.search ? '?' + url.searchParams.toString() : ''));
  });

  // Sort change
  const sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      fetchAndReplace(url.pathname + '?' + url.searchParams.toString());
    });
  }

  // Mobile filter drawer toggle handled by data-drawer-open

  window.addEventListener('popstate', () => {
    fetchAndReplace(window.location.pathname + window.location.search);
  });
})();
